import { Component, OnInit, Signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineLatest, map, tap, Observable } from 'rxjs';
import { EnterpriseType } from 'src/app/models/enterpriseType.model';
import { LandUseType } from 'src/app/models/landUseType.model';
import { PaddockDexie } from 'src/app/models/paddock.model';
import { DropDownService } from 'src/app/services/dropdown.service';
import { CustomValidators } from 'src/app/_helpers/customValidators';
import { MatFormFieldModule } from '@angular/material/form-field';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-create-paddock',
    templateUrl: './create-paddock.component.html',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatDialogModule,MatFormFieldModule]
})
export class CreatePaddockComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CreatePaddockComponent>>(MatDialogRef);
  paddock = inject<PaddockDexie>(MAT_DIALOG_DATA);
  dropdownService = inject(DropDownService);



  createPaddockForm = new UntypedFormGroup(
      {
      'cropType': new UntypedFormControl(null, CustomValidators.required),
      'landuseType': new UntypedFormControl(null, CustomValidators.required),
      'name': new UntypedFormControl(null, CustomValidators.required),
      'notes': new UntypedFormControl(null)
    },
    );

private landuseCtrl = this.createPaddockForm.get('landuseType') as FormControl<LandUseType | null>;

private filteredEnterpriseTypes$: Observable<EnterpriseType[]> =
  combineLatest<[EnterpriseType[], LandUseType | null]>([
    this.dropdownService.enterpriseTypes,
    this.landuseCtrl.valueChanges
  ]).pipe(
    map(([enterpriseTypes, landUseType]) =>
      landUseType
        ? enterpriseTypes.filter(et => et.landUseTypeID === landUseType.landUseTypeID)
        : []
    )
  );

  filteredEnterpriseTypes = toSignal(this.filteredEnterpriseTypes$,{initialValue: []}) as Signal<EnterpriseType[]>

  ngOnInit(): void {
    this.dialogRef.disableClose = true;

  }

  submit()
  {
    this.paddock.name = this.createPaddockForm.get('name').value;
    this.paddock.enterpriseType = this.createPaddockForm.get('cropType').value.name;
    this.paddock.landUseType = this.createPaddockForm.get('landuseType').value.name;
    this.paddock.notes = this.createPaddockForm.get('notes').value;

    this.dialogRef.close(this.paddock);
  }

}
